import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import CategoryCard from './CategoryCard';
import useWindowWidth from '../hooks/useWindowWidth';
import SliderArrow from './SliderArrow';

export default function Categories({ categories }) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    variableWidth: true,
    arrows: true,
    prevArrow: <SliderArrow type="categories" direction="prev" />,
    nextArrow: <SliderArrow type="categories" direction="next" />,
    slidesToScroll: 3,
  };

  const windowWidth = useWindowWidth();

  const categoryElements = categories.map(c => (
    <CategoryCard
      key={c.name}
      image={c.image_url}
      name={c.name}
      page={c.slug}
    />
  ));

  return (
    <div className="listings-categories">
      {windowWidth > 768 ? (
        <Slider {...settings}>{categoryElements}</Slider>
      ) : (
        <div className="listings-overflow">{categoryElements}</div>
      )}
    </div>
  );
}

Categories.propTypes = {
  categories: PropTypes.array.isRequired,
};
